(function() {
  'use strict';

  angular.module('component.blueprints')
    .component('blueprint', {
      templateUrl: 'app/components/blueprints/form.html',
      controller: 'BlueprintController',
      controllerAs: 'blueprintCtrl',
      bindings: {
        blueprintId: '<',
        defaults: '<'
      }
    });
})();
